import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { useError, useLoader, useNotification, useGoogleMapApi, } from "@piiqtechnologies/ui-lib";
import { useCreateAiDiscoverabilityAssessment } from "@piiqtechnologies/ui-lib/lib/apis/ai-discoverability/useCreateAiDiscoverabilityAssessment";
import messages from "./messages.i18n";
import { AiDiscoverabilityFormInitialValues, AiDiscoverabilityFormValidationSchema, getAiDiscoverabilityFormFields, } from "./AiDiscoverabilityConfig";
import { Divider } from "@mui/material";
import { MultiColumnFormFields } from "@components/common/form/FormFields";
export const AiDiscoverabilityForm = ({ onResult }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setNotification } = useNotification();
    const { mapAPiloaded } = useGoogleMapApi();
    const [createAiDiscoverabilityAssessment, aiDiscoverabilityAssessmentCreated, createAiDiscoverabilityAssessmentInProgress, createAiDiscoverabilityAssessmentError,] = useCreateAiDiscoverabilityAssessment();
    useEffect(() => {
        setLoader(createAiDiscoverabilityAssessmentInProgress, "createAiDiscoverabilityAssessmentInProgress");
        return () => setLoader(false, "createAiDiscoverabilityAssessmentInProgress");
    }, [createAiDiscoverabilityAssessmentInProgress]);
    useEffect(() => {
        if (createAiDiscoverabilityAssessmentError)
            setError(createAiDiscoverabilityAssessmentError === null || createAiDiscoverabilityAssessmentError === void 0 ? void 0 : createAiDiscoverabilityAssessmentError.message);
    }, [createAiDiscoverabilityAssessmentError]);
    useEffect(() => {
        if (aiDiscoverabilityAssessmentCreated) {
            setNotification(intl.formatMessage(messages.aiDiscoverabilityResultsSuccessfulTitle));
            onResult(aiDiscoverabilityAssessmentCreated);
        }
    }, [aiDiscoverabilityAssessmentCreated]);
    const getAddressValue = (address) => {
        if (!address)
            return undefined;
        if (typeof address === "string")
            return address;
        return address.description || address.name;
    };
    const onCreateAiDiscoverabilityAssessment = (values) => {
        createAiDiscoverabilityAssessment(Object.assign(Object.assign({}, values), { subjectAddress: getAddressValue(values.subjectAddress) }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Formik, { initialValues: AiDiscoverabilityFormInitialValues, validationSchema: AiDiscoverabilityFormValidationSchema(), onSubmit: () => { } }, ({ values, isValid, dirty }) => (React.createElement(Form, null,
            React.createElement(PeekStack, { gap: 1 },
                React.createElement(PeekTypography, { variant: "h3" }, intl.formatMessage(messages.aiDiscoverabilityFormTitle)),
                React.createElement(Divider, { light: true }),
                React.createElement(MultiColumnFormFields, { fields: getAiDiscoverabilityFormFields(mapAPiloaded) }),
                React.createElement(PeekStack, { direction: "column", gap: 1 },
                    React.createElement(PeekButton, { fullWidth: true, size: "large", color: "primary", variant: "contained", disabled: !isValid || !dirty, onClick: () => onCreateAiDiscoverabilityAssessment(values) }, intl.formatMessage(messages.aiDiscoverabilityAssessmentButtonLabel)))))))));
};
export default AiDiscoverabilityForm;
